module.exports = __webpack_public_path__ + "img/detail_eye_open.008155ec.svg";